"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _designSystem = require("@superlogica/design-system");

var _SortBy = _interopRequireDefault(require("./SortBy"));

var _styles = require("./styles");

var TableHead = function TableHead(_ref) {
  var headerGroups = _ref.headerGroups;
  return /*#__PURE__*/_react.default.createElement(_styles.THead, null, headerGroups.map(function (headerGroup) {
    return /*#__PURE__*/_react.default.createElement("tr", headerGroup.getHeaderGroupProps(), headerGroup.headers.map(function (column) {
      return column.render('Header') ? /*#__PURE__*/_react.default.createElement(_styles.Th, Object.assign({}, column.getHeaderProps(column.getSortByToggleProps()), {
        width: column.width || 'auto'
      }), /*#__PURE__*/_react.default.createElement(_designSystem.Text, {
        size: "body02",
        weight: "bold",
        color: "neutral700",
        align: column.align
      }, column.render('Header')), /*#__PURE__*/_react.default.createElement("span", null, column.render('Header') && /*#__PURE__*/_react.default.createElement(_SortBy.default, {
        fillUp: column.isSorted && !column.isSortedDesc,
        fillDown: column.isSortedDesc
      }))) : /*#__PURE__*/_react.default.createElement(_styles.Th, {
        key: "white-space",
        width: column.actionWidth
      });
    }));
  }));
};

var _default = TableHead;
exports.default = _default;